export enum ZoomableValueExtractionMethod {
    Static = "Static",
    Closest = "Closest",
    Continuous = "Continuous"
}